export const setupIsHideField = (useQrpFields) => {
  const data = useQrpFields({ ready: true });
  const {
    isShowNationalId = false,
    isShowGender = false,
    isShowDob = false
  } = data || {};
  return {isShowNationalId, isShowGender, isShowDob};
};